import { z } from 'zod';
import { authoringBlockSchema } from './authoring';
import { themeSchema } from './ir.schema';

export const EDITOR_CLIPBOARD_KIND = 'personalizehq/subtrees' as const;
export const EDITOR_CLIPBOARD_VERSION = 1 as const;

export const editorClipboardEnvelopeSchema = z.strictObject({
  kind: z.literal(EDITOR_CLIPBOARD_KIND),
  version: z.literal(EDITOR_CLIPBOARD_VERSION),
  source: z.strictObject({
    appId: z.string().min(1),
    experienceId: z.string().min(1),
    stepId: z.string().min(1),
  }),
  copiedAt: z.number().int().nonnegative(),
  roots: z.array(authoringBlockSchema).min(1),
  labels: z.record(z.string(), z.string().min(1).max(80)),
  theme: z.strictObject({
    fonts: themeSchema.shape.fonts,
    colors: themeSchema.shape.colors,
    buttons: themeSchema.shape.buttons,
    radii: themeSchema.shape.radii,
    elevations: themeSchema.shape.elevations,
    gradients: themeSchema.shape.gradients,
  }),
  assets: z.array(z.strictObject({ id: z.string().min(1), url: z.string() })),
  campaignIds: z.array(z.string().min(1)),
});

export type EditorClipboardEnvelope = z.infer<typeof editorClipboardEnvelopeSchema>;
